import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AlertMessage } from 'src/app/template/models/alert-message.model';

@Component({
    selector: 'app-enrollment-new-old',
    templateUrl: './enrollment-new.component.html',
    styleUrls: ['./enrollment-new.component.scss']
})
export class EnrollmentNewComponent implements OnInit {

    public headerTitle     : string = 'Inscripciones';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/inscripciones';

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    constructor() { }

    ngOnInit(): void { }

}
